import { useChangeTracker } from '@aibees/elephant/feature/account-magement-drawer/context/change-tracker';
import { ConfirmDialog } from '@aibees/shared/components';
import { useBoolean } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils/class-names';
import { Button, Typography } from '@mui/material';
import { memo, useState } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { DowngradeToFreeProps as Props } from './types';

export const DowngradeToFree = memo(
  ({ className, isDowngraded, setIsDowngraded }: Props) => {
    const state = useBoolean();
    const { markDirty } = useChangeTracker();
    const [dialogMode, setDialogMode] = useState<'downgrade' | 'cancel'>(
      'downgrade'
    );

    const handleOpenDowngradeDialog = () => {
      setDialogMode('downgrade');
      state.onTrue();
    };

    const handleOpenCancelDialog = () => {
      setDialogMode('cancel');
      state.onTrue();
    };

    const handleConfirm = () => {
      if (dialogMode === 'downgrade') {
        setIsDowngraded(true);
      } else {
        setIsDowngraded(false);
      }
      markDirty();
      state.onFalse();
    };

    return (
      <>
        <Styled.Wrapper className={classnames('DowngradeToFree', className)}>
          {isDowngraded ? (
            <Button
              variant="contained"
              color="warning"
              size="medium"
              onClick={handleOpenCancelDialog}
              sx={SX.button}
            >
              Cancel downgrade
            </Button>
          ) : (
            <Button
              variant="contained"
              color="primary"
              size="medium"
              onClick={handleOpenDowngradeDialog}
              sx={SX.button}
            >
              Downgrade to free
            </Button>
          )}
        </Styled.Wrapper>

        <ConfirmDialog
          state={state}
          onCancel={state.onFalse}
          onOk={handleConfirm}
          title={
            <Typography variant="body2" color="grey.800" fontWeight={600}>
              {dialogMode === 'downgrade'
                ? 'Downgrading to Free Plan'
                : 'Cancel Downgrade'}
            </Typography>
          }
          content={
            <Typography variant="body3" color="grey.900" fontWeight={500}>
              {dialogMode === 'downgrade'
                ? 'Are you sure you want to cancel the 9,000 Credit/ Monthly Plan?'
                : 'Are you sure you want to cancel downgrade?'}
            </Typography>
          }
          okTitle={dialogMode === 'downgrade' ? 'Confirm Downgrade' : 'Confirm'}
          cancelTitle="Cancel"
          okProps={{ variant: 'contained', color: 'primary' }}
          cancelProps={{ variant: 'text', color: 'inherit' }}
          titleSx={SX.root}
          actionsSx={SX.actions}
          headerSx={SX.header}
          maxWidth="md"
        />
      </>
    );
  }
);

DowngradeToFree.displayName = 'DowngradeToFree';
